import { useTranslation } from 'react-i18next';

import { PageSubHeader } from '@/components/organisms/PageSubHeader';
import PageContentWrapper from '@/components/templates/PageContentWrapper';
import { useAudiencePage, useErrorChipsFilter } from '@/modules/campaigns/hooks/useAudiencePage';
import { TABLE_LAYOUT_FILL_FULL_WIDTH_CLASSES } from '@/util/constants';

import {
  AudienceErrorChipsBar,
  AudienceIssueRow,
  AudienceSectionHeader,
  ReviewAudienceTable,
} from '../../components/AudienceReview';
import { AudienceToolbar } from '../../components/AudienceToolbar';
import { CampaignBreadcrumbs } from '../../components/CampaignBreadcrumbs';

export const Audience = () => {
  const { t } = useTranslation();

  const page = useAudiencePage();

  const {
    errorCount,
    errorNames,
    errorFilterActive,
    visibleChips,
    tableData,
    tableRowCount,
    showErrors,
    removeChip,
  } = useErrorChipsFilter(page);

  return (
    <>
      <PageSubHeader
        breadcrumbs={
          <CampaignBreadcrumbs
            campaignName={page.campaignName}
            currentStep={t('campaigns.audience')}
          />
        }
      />

      <PageContentWrapper noGutters>
        <div className={TABLE_LAYOUT_FILL_FULL_WIDTH_CLASSES}>
          {errorCount > 0 && (
            <div className="mb-4 shrink-0">
              {/* The bar counts warning types, not affected subscribers (today just validation errors). */}
              <AudienceSectionHeader
                variant="warning"
                title={t('campaigns.audience_warnings.title')}
                count={1}
              />
              <AudienceIssueRow
                title={t('campaigns.audience_warnings.error_count', { count: errorCount })}
                detail={errorNames}
                actionLabel={t('campaigns.audience_warnings.view')}
                onAction={showErrors}
              />
            </div>
          )}

          <AudienceToolbar page={page} />

          {errorFilterActive && (
            <AudienceErrorChipsBar chips={visibleChips} onRemove={removeChip} />
          )}

          <ReviewAudienceTable page={page} data={tableData} rowCount={tableRowCount} />
        </div>
      </PageContentWrapper>
    </>
  );
};
